import { Button } from '@common/components';

import { Image } from '@/components/client';

interface PointEmptySectionProps {
  mainMessage: string;
  subMessage?: string;
  actionButton?: {
    text: string;
    onClick: VoidFunction;
  };
}

export const PointEmptySection = ({
  mainMessage,
  subMessage,
  actionButton,
}: PointEmptySectionProps) => {
  return (
    <section className="flex-col break-keep px-20 py-24 text-center flex-center">
      <strong className="font-700 text-Gray-900 typo-body2">
        {mainMessage}
      </strong>
      <Image
        alt="코인"
        className="my-8"
        height={90}
        src="/assets/pngs/silver-coin.png"
        width={90}
      />
      {subMessage ? (
        <p className="whitespace-pre-wrap font-400 text-Gray-600 typo-body4">
          {subMessage}
        </p>
      ) : null}
      {actionButton ? (
        <Button className="mt-20" onClick={actionButton.onClick}>
          {actionButton.text}
        </Button>
      ) : null}
    </section>
  );
};
